import { BaseRequestModel } from '../../base/base.request.model';

export class RemoveDeviceRequestMessage {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  RemoveDeviceReqMessage!: RemoveDeviceReqMessage;
}

class RemoveDeviceReqMessage extends BaseRequestModel {
  serialNo!: string;
  cpCustomerID?: string;
}
